import {
  ballArr,
  count,
  singleDouble,
  singleDoubleCnname,
  smallBig,
  continuity,
  continuityCnname,
  smallBigCnname,
  dragonTiger,
  fishCnname
} from "../../../../helpers/resPatterns";
import dayjs from "dayjs";

// let treeChildren = (index, data) => {
//   var arr = [];
//   if (data) {
//     for (let i = 0; i < 10; i++) {
//       var obj = {};
//       obj.title = `${i}`;
//       obj.align = 'center';
//       obj.width = '34';
//       obj.className = `tree_table_children_${index}`;
//       obj.render = (h, row) => {
//         // if (row.row.lostInfo[index][i] == 0) {
//         //   data[row.index].show = true;
//         //   return <span class="red">{data[row.index].issueResult[index]}</span>;
//         // } else {
//         //   return <span class="lost_info">{row.row.lostInfo[index][i]}</span>;
//         // }
//       };
//       arr.push(obj);
//     }
//     return arr;
//   }
// };
let treeChildren = (data, index) => {
  var arr = [];
  var shape = ["大", "小", "单", "双"];
  var str = ["big", "small", "single", "double"];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = "center";
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var num = row.row.ball_history_json[name][str[i]];
        return <span>{num ? num : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};
let treeChildren1 = (data, key) => {
  var str = ["big", "small", "single", "double"];
  var shape = ["大", "小", "单", "双"];
  if (data) {
    return (h, row) => {
      return (
        <div>
          <div>
            <span>
              {shape[0]}/
              {row.row.ball_history_json[key][str[0]]
                ? row.row.ball_history_json[key][str[0]]
                : 0}
            </span>
            <span>
              {shape[1]}/
              {row.row.ball_history_json[key][str[1]]
                ? row.row.ball_history_json[key][str[1]]
                : 0}
            </span>
          </div>
          <div>
            <span>
              {shape[2]}/
              {row.row.ball_history_json[key][str[2]]
                ? row.row.ball_history_json[key][str[2]]
                : 0}
            </span>
            <span>
              {shape[3]}/
              {row.row.ball_history_json[key][str[3]]
                ? row.row.ball_history_json[key][str[3]]
                : 0}
            </span>
          </div>
        </div>
      );
    };
  } else {
    return;
  }
};

const ssc = data => {
  let list = Vue => {
    let arr = [
      {
        title: "日期",
        align: "center",
        key: "date",
        className: `table_issueId`,
        width: 150
      }
    ];
    var a = ["一", "二", "三", "四", "五", "六", "七", "八", "九"];
    var titleJson = [
      {
        key: "ball1",
        name: "球1"
      },
      {
        key: "ball2",
        name: "球2"
      },
      {
        key: "ball3",
        name: "球3"
      },
      {
        key: "ball4",
        name: "球4"
      },
      {
        key: "ball5",
        name: "球5"
      }
    ];
    var keys = Object.keys(data[0].ball_history_json);
    if (Vue.showMobile) {
      for (let i = 0; i < titleJson.length; i++) {
        let obj = {
          title: titleJson[i].name,
          render: treeChildren1(data, titleJson[i].key),
          renderHeader: (h, params) => {
            return (
              <div
                class="showBallHandle"
                on-click={_ => (Vue.showballIndex = i)}
                class={Vue.showballIndex == i && "active"}
              >
                {titleJson[i].name}
              </div>
            );
          }
        };

        arr.push(obj);
      }
    } else {
      for (let i = 0; i < keys.length; i++) {
        let obj = {};
        let e = a[i];
        obj.title = `第${e}球`;
        obj.align = "center";
        obj.width = "300";
        obj.key = "resultStr";
        obj.className = `table_info_column_${i}`;
        obj.children = treeChildren(data, i);
        arr.push(obj);
      }
    }
    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Daxiaodanshuanglishi/columns/ssc.js